import { useState } from "react";
import Backimg from "../../assets/img/skip-arrow.svg";
import useTranslator from "../../hooks/useTranslator";
import { useNavigate } from "react-router-dom";
import Cancelimg from "../../assets/img/cancel-01.svg";
import UserSpecificIncomeModel from "./UserSpecificIncomeModel";
import { haveValue } from "../../helper/common";

const TenantChecksIncomeModel = ({
  user,
  updateUserProfile,
  isGuarantor,
  loadGuarantorData,
  usedFor,
  setBankshow,
  loadFullInfo,
  setPaymentScoreLoading,
  reconnectFlow = false,
  getAnalysisDetails,
  setScoreValue,
  additionalInfo,
  formHandler,
  setShowPassedModal,
}) => {
  const { _t } = useTranslator();
  const navigate = useNavigate();
  const [bankShow, setBankShow] = useState(false);
  const queryParameters = new URLSearchParams(window.location.search);
  const reCheck = queryParameters.get("reCheck");
  const [submitStepLoading, setSubmitStepLoading] = useState(false);
  const [doItLaterLoading, setDoItLaterLoading] = useState(false);

  const handleDoItLater = async () => {
    if (doItLaterLoading) {
      return;
    }

    try {
      setDoItLaterLoading(true);
      const user_id = user?._id;
      setShowPassedModal(true);
    } catch (err) {
    } finally {
      setDoItLaterLoading(false);
    }
  };

  const handleSubmitStep = async () => {
    try {
      const user_id = user?._id;
      setShowPassedModal(true);
    } catch (err) {
      console.log("Error", err);
    } finally {
      setSubmitStepLoading(false);
    }
  };

  return (
    <>
      <div
        className={`approvedModal popup-overlay fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50 wrapper-modal modal-fixed-screen ${
          isGuarantor ? "guarantorBg" : ""
        }`}
        onClick={usedFor === "popup" ? () => setBankshow(false) : null}
      >
        {!bankShow && (
          <div
            className={`popup-content2 position-relative popup-content bg-white required-doc-popup verifyIncomeModal ${
              !additionalInfo.includes("GUARANTOR_SKOR")
                ? "verifyIncomeModalSmall"
                : ""
            }`}
            style={{ width: isGuarantor ? "55%" : "" }}
            onClick={
              usedFor === "popup" || isGuarantor
                ? (e) => e.stopPropagation()
                : null
            }
          >
            {usedFor === "popup" && (
              <div
                className="cursor-pointer"
                onClick={() => setBankshow(false)}
              >
                <img
                  src={Cancelimg}
                  alt="icon"
                  className="canceicon topRightIcon"
                />
              </div>
            )}

            <div className="row relativeposition position-relative">
              <div className="col-12 d-flex gap-4 align-items-center justify-content-center heading-section guarantorModal">
                <div
                  onClick={() => {
                    if (haveValue(reCheck) && reCheck) {
                      navigate(-1);
                    } else {
                      formHandler.prev();
                    }
                  }}
                  className="getback-btn"
                >
                  <img
                    src={Backimg}
                    alt="icon"
                    className="canceicon"
                    style={{ rotate: "180deg" }}
                  />
                </div>
                <div className="authenticateid-header authenticateidHeader text-center">
                  <div className="customHeader">
                    <h4>
                      {_t(
                        "verifyIncome",
                        "Text used at popup screen to connect bank"
                      )}
                    </h4>
                    <p className="word-break">
                      {_t(
                        "verifyTenantAndGuarantorBankAccountByUploadingBankStatements",
                        "Text used at popup screen to connect bank"
                      )}
                    </p>
                  </div>
                </div>
              </div>
              {usedFor !== "popup" && !haveValue(reCheck) && (
                <div
                  className="skipbtn cursor-pointer skipButtonDesktop greenHover"
                  onClick={handleDoItLater}
                >
                  <p>
                    {_t(
                      "iWillDoItLater",
                      "Text used in guarantor screen at onboarding flow"
                    )}
                  </p>
                  <img src={Backimg} alt="icon" className="canceicon" />
                </div>
              )}
            </div>
            <div
              className={`d-flex align-items-center justify-center verifyIncomeCardContainer ${
                !additionalInfo.includes("GUARANTOR_SKOR")
                  ? "verifyIncomeCardSmall"
                  : ""
              }`}
            >
              <UserSpecificIncomeModel
                user={user}
                isGuarantor={isGuarantor}
                loadGuarantorData={loadGuarantorData}
                usedFor={usedFor}
                updateUserProfile={updateUserProfile}
                setScoreValue={setScoreValue}
                setPaymentScoreLoading={setPaymentScoreLoading}
                loadFullInfo={loadFullInfo}
                getAnalysisDetails={getAnalysisDetails}
                reconnectFlow={reconnectFlow}
              />
              {additionalInfo.includes("GUARANTOR_SKOR") && (
                <UserSpecificIncomeModel
                  user={user?.gurantor_id?.[0]}
                  isGuarantor={true}
                  loadGuarantorData={loadGuarantorData}
                  usedFor={usedFor}
                  updateUserProfile={updateUserProfile}
                  setScoreValue={setScoreValue}
                  setPaymentScoreLoading={setPaymentScoreLoading}
                  loadFullInfo={loadFullInfo}
                  getAnalysisDetails={getAnalysisDetails}
                  reconnectFlow={reconnectFlow}
                  llGuarantor={true}
                />
              )}
            </div>
            <div className="d-flex guarantorButtonWrapper submitTenantChecks justify-content-center align-items-center">
              <button
                onClick={(e) => {
                  if (haveValue(reCheck) && reCheck) {
                    navigate(-1);
                  } else {
                    handleSubmitStep();
                  }
                }}
                disabled={submitStepLoading}
                className="btnNext addGuarantorButton submitButton greenHover"
              >
                {submitStepLoading ? _t("submitting") : _t("submit")}
              </button>
            </div>
          </div>
        )}
      </div>
    </>
  );
};

export default TenantChecksIncomeModel;
